import {
  collection,
  doc,
  getDocs,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore'

import { firestore } from '../../firebase/firebaseConfig'
import { UIVersion } from '../../types'

export interface UIRolloutProfile {
  uid: string
  name: string
  lastname: string
  email: string
  uiVersion: UIVersion
}

const normalizeUIVersion = (value: unknown): UIVersion =>
  value === 'redesign' ? 'redesign' : 'legacy'

export const listStudentUIRolloutProfiles = async (): Promise<
  UIRolloutProfile[]
> => {
  const snapshot = await getDocs(collection(firestore, 'students'))

  return snapshot.docs
    .map((studentDocument) => {
      const data = studentDocument.data()

      return {
        uid: studentDocument.id,
        name: typeof data.name === 'string' ? data.name : '',
        lastname: typeof data.lastname === 'string' ? data.lastname : '',
        email: typeof data.email === 'string' ? data.email : '',
        uiVersion: normalizeUIVersion(data.uiVersion),
      }
    })
    .sort((first, second) =>
      `${first.name} ${first.lastname}`.localeCompare(
        `${second.name} ${second.lastname}`,
        'es',
        { sensitivity: 'base' },
      ),
    )
}

export const updateStudentUIVersion = async ({
  administratorId,
  studentId,
  uiVersion,
}: {
  administratorId: string
  studentId: string
  uiVersion: UIVersion
}) => {
  await updateDoc(doc(firestore, 'students', studentId), {
    uiVersion,
    uiVersionUpdatedAt: serverTimestamp(),
    uiVersionUpdatedBy: administratorId,
  })
}
